var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.729,
    height: 17.911,
    viewBox: "0 0 19.729 17.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M18.288,20.061H3.741A2.594,2.594,0,0,1,1.15,17.47V4.741A2.594,2.594,0,0,1,3.741,2.15H8.287a.773.773,0,0,1,.643.344l1.589,2.383h7.769a2.594,2.594,0,0,1,2.591,2.591v10A2.594,2.594,0,0,1,18.288,20.061ZM3.741,3.7A1.047,1.047,0,0,0,2.7,4.741V17.47a1.047,1.047,0,0,0,1.046,1.046H18.288a1.047,1.047,0,0,0,1.046-1.046v-10a1.047,1.047,0,0,0-1.046-1.046H10.106a.773.773,0,0,1-.643-.344L7.874,3.7Z",
    transform: "translate(-1.15 -2.15)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProProject);
export default __webpack_public_path__ + "static/media/pro_Project.a5f2dcbe1171459b4b835bee9af4616e.svg";
export { ForwardRef as ReactComponent };